import React, {Component} from 'react'
import Modal from 'react-modal'

class HelpAndFeedbackModal extends Component {
    constructor(props){
        super(props)

        this.dissmissHelp = this.dissmissHelp.bind(this)
    }

    dissmissHelp(){
        const { setIsOpenHelpAndFeedback } = this.props
        setIsOpenHelpAndFeedback(false)
    }

    render(){
        const { isOpenHelpAndFeedback } = this.props
        return  <Modal  isOpen={isOpenHelpAndFeedback}
                        onRequestClose={this.dissmissHelp} 
                        className="modal is-active"
                        overlayClassName="modal-overlay"
                        htmlOpenClassName="ReactModal__Html--open">
                        <div className="modal-background"></div>
                        <div className="modal-content modal-alert">
                            <div className="UploadProgressContentBox box">
                                <div className="content">
                                    <h4 className="UploadProgressHeading title is-size-4 is-size-5-mobile has-text-white is-center">Introduction</h4>
                                    <iframe title="introduction" width="600" height="315" src="https://www.youtube.com/embed/8VXrB9Lm6mo" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe><br/><br/>
                                    <h4 className="UploadProgressHeading title is-size-4 is-size-5-mobile has-text-white is-center">How to Use</h4>
                                    <iframe title="How to use" width="600" height="315" src="https://www.youtube.com/embed/5MNWB-Iecaw" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe><br/><br/>
                                    <h4 className="UploadProgressHeading title is-size-4 is-size-5-mobile has-text-white is-center">Use case</h4>
                                    <iframe title="Use case" width="600" height="315" src="https://www.youtube.com/embed/KriqZRFWoUY" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe><br/><br/>
                                    <h4 className="UploadProgressHeading title is-size-4 is-size-5-mobile has-text-white is-center">Upload</h4>
                                    <iframe title="Use case" width="600" height="315" src="https://www.youtube.com/embed/6Rlp6l4713g" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe><br/><br/>
                                </div>
                                <div className="UploadProgressClose icon is-large has-text-grey" onClick={this.dissmissHelp}><i className="fas fa-times"></i></div>
                            </div> 
                        </div>
                </Modal>
                
    }
}

export default HelpAndFeedbackModal


// WEBPACK FOOTER //
// ./src/PageMaps/_HelpAndFeedbackModal.js